import { userGetCurrent } from '@uncinc/react-drupal-core';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import { MessageEntity, Thunk } from '../../../types';
import { viewReset } from '../Entity/View';

export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
export const newMessageAdded = (message: MessageEntity) => ({
  type: ADD_NEW_MESSAGE,
  message,
});

export const RESET_NEW_MESSAGE = 'RESET_NEW_MESSAGE';
export const resetNewMessage = () => ({
  type: RESET_NEW_MESSAGE,
});

export const RESET_MESSAGES = 'RESET_MESSAGES';
export const messagesReset = () => ({
  type: RESET_MESSAGES,
});

export const fetchMessages = (): Thunk => (
  (dispatch) => {
    dispatch(viewGet('message', 'block_1', 0, null, {}));
  }
);

export const addNewMessage = (message: MessageEntity): Thunk => (
  (dispatch) => {
    const messageHasBadge = !!message.field_badge;

    dispatch(newMessageAdded(message));

    if (messageHasBadge) {
      // Fetch the user data to get the new badge in the state.
      dispatch(userGetCurrent());
    }
  }
);

export const resetMessages = (): Thunk => (
  (dispatch) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    dispatch(viewReset('message'));
    dispatch(messagesReset());
  }
);
